import React from "react"
import { IDispatchRule } from "@/types/dispatchRules.types"
import CompactDispatchRuleCard from "./CompactViewDispatchRuleCard"
import FullViewDispatchRuleCard from "./FullViewDispatchRuleCard"

interface DispatchRuleCardProps {
  rule: IDispatchRule
  view?: "full" | "compact"
}

const DispatchRuleCard: React.FC<DispatchRuleCardProps> = ({ rule, view = "full" }) => {
  return view === "full" ? (
    <FullViewDispatchRuleCard rule={rule} />
  ) : (
    <CompactDispatchRuleCard rule={rule} />
  )
}

export default DispatchRuleCard
